// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3i9am","content":"styles_content__37z0W","selectAll":"styles_selectAll__3tk4H"};